var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3466 19.4329L19.6922 18.0873L18.3466 16.7416L17.0009 18.0873L18.3466 19.4329Z",
    fill: "url(#paint0_linear_427_14)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.977539 3.48816C0.977539 1.73645 2.39758 0.316406 4.14928 0.316406H33.9637C35.7154 0.316406 37.1354 1.73645 37.1354 3.48815V33.3026C37.1354 35.0543 35.7154 36.4743 33.9637 36.4743H4.14929C2.39758 36.4743 0.977539 35.0543 0.977539 33.3026V3.48816ZM18.3466 19.4329L19.6922 18.0873L22.9075 21.3025C23.2791 21.6741 23.279 22.2766 22.9075 22.6482C22.5359 23.0198 21.9334 23.0198 21.5618 22.6482L18.3466 19.4329ZM17.0009 18.0873L13.7025 21.3857C13.3309 21.7573 13.3309 22.3597 13.7025 22.7313C14.0741 23.1029 14.6766 23.1029 15.0482 22.7313L18.3466 19.4329L17.0009 18.0873ZM18.3466 16.7416L21.3279 13.7603C21.6995 13.3887 22.302 13.3887 22.6736 13.7603C23.0452 14.1319 23.0452 14.7344 22.6736 15.1059L19.6922 18.0873L18.3466 16.7416ZM18.3466 16.7416L15.2821 13.6771C14.9105 13.3055 14.308 13.3055 13.9364 13.6771C13.5648 14.0487 13.5648 14.6512 13.9364 15.0228L17.0009 18.0873L18.3466 16.7416ZM18.4214 29.4981C24.5524 29.4981 29.5225 24.528 29.5225 18.397C29.5225 12.266 24.5524 7.2959 18.4214 7.2959C12.2904 7.2959 7.32031 12.266 7.32031 18.397C7.32031 24.528 12.2904 29.4981 18.4214 29.4981Z",
    fill: "url(#paint1_linear_427_14)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_427_14",
    x1: 13.0303,
    y1: 18.2029,
    x2: 23.5809,
    y2: 18.2029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#960E0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_427_14",
    x1: 0.977539,
    y1: 18.3954,
    x2: 37.1354,
    y2: 18.3954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#960E0E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.d7cc4d2077782ae42eb6c82f58c7fc07.svg";
export { ForwardRef as ReactComponent };